<template>
  <div class="card">
    <div class="card-header text-center py-2">{{ titulo }}</div>
    <div class="card-body" v-if="verForm">
      <form @submit.prevent="guardarMesa">
        <div class="form-group row mb-1">
          <label for="selectRestaurante" class="col-sm-2 col-form-label">Restaurante:</label>
          <div class="col-sm-4">
            <select id="selectRestaurante" class="form-control form-control-sm" v-model="form.carta_restaurante_id" @change="getMesas">
              <option v-for="i in catalogo.restaurante" :key="i.id" :value="i.id">{{ i.nombre }}</option>
            </select>
          </div>
          <label for="selectMesa" class="col-sm-2 col-form-label">Mesa:</label>
          <div class="col-sm-4">
            <select id="selectMesa" class="form-control form-control-sm" v-model="form.carta_mesa_id">
              <option :value="null">----------</option>
              <option v-for="i in mesas" :key="i.id" :value="i.id">{{ i.descripcion }}</option>
            </select>
          </div>
        </div>
        <div class="form-group row mb-1">
          <label for="inputMensaje" class="col-sm-2 col-form-label">Mensaje:</label>
          <div class="col-sm-4">
            <textarea id="inputMensaje" rows="3" v-model="form.mensaje" class="form-control form-control-sm"></textarea>
          </div>
          <div class="col-sm-2"></div>
          <div class="col-sm-2">
            <div class="form-check" v-if="reg">
              <input
                class="form-check-input"
                type="checkbox"
                id="inputAnulado"
                v-model="form.anulado"
                true-value="1"
                false-value="0">
              <label class="form-check-label" for="inputAnulado">
                Anular enlace
              </label>
            </div>
          </div>
          <div class="col-sm-2 text-right">
            <button
              type="button"
              class="btn btn-sm btn-secondary mr-1"
              v-if="reg !== ''"
              @click.prevent="limpiar"
            >
              Nuevo
            </button>
            <button type="submit" class="btn btn-sm btn-primary" :disabled="btnGuardar">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                v-if="btnGuardar"
              ></span>
              <span class="sr-only" v-if="btnGuardar">
                {{ reg === '' ? 'Guardando...':'Actualizando...' }}
              </span>
              <span v-if="!btnGuardar">
                {{ reg === '' ? 'Guardar':'Actualizar' }}
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-muted p-1">
      <span v-if="inicio">Buscando...</span>
      <div class="input-group input-group-sm mb-0" v-else>
        <input 
          type="text" 
          class="form-control" 
          v-model="listaTermino"
          placeholder="Buscar por restaurante" 
          aria-label="Buscar por restaurante" 
          aria-describedby="btnBuscarNombre"
        >
        <div class="input-group-append">
          <button 
            class="btn btn-outline-secondary px-3" 
            type="button" 
            @click="verForm = !verForm"
            id="btnBuscarNombre"
          >
            <font-awesome-icon icon="angle-up" v-if="verForm"/>
            <font-awesome-icon icon="angle-down" v-else/>
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive" v-if="!inicio">
      <table class="table table-sm">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Restaurante</th>
            <th scope="col">Mesa</th>
            <th scope="col">Mensaje</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(i, idx) in filtrada" :key="i.id">
            <th scope="row">{{ idx + 1 }}</th>
            <td><a href="#" @click.prevent="editar(idx)">{{ i.nrestaurante }}</a></td>
            <td>{{ i.nmesa }}</td>
            <td>{{ i.mensaje }}</td>
            <td><a
              :href="'/carta.php/enlace/get_qr/'+i.id"
              target="_blank"
              class="btn btn-sm btn-light border"
              title="Obtener QR">
              <font-awesome-icon icon="images" />
            </a></td>
            <td>
              <a :href="'/carta.php/enlace/visitar/'+i.id" target="_blank">Ver</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import CartaCatalogo from '../mixins/CartaCatalogo.js';
  import ManteAccion from '../mixins/ManteAccion.js';
  export default {
    name: 'ManteCartaEnlace',
    mixins: [CartaCatalogo,ManteAccion],
    data: () => ({
      titulo: 'Enlace',
      mesas: [],
      imgQr: null
    }),
    created () {
      this.nombre = 'enlace';
      this.listaFiltrar = 'nrestaurante';
      this.getCatalogo(["restaurante"]);
    },
    methods: {
      getMesas () {
        axios
        .get(this.UrlBase+'/catalogo/get_mesa?restaurante='+this.form.carta_restaurante_id)
        .then(res => {
          this.mesas = res.data.lista;
        }).catch(e => {
          alert('Mesas '+e);
        });
      },
      guardarMesa () {
        this.btnGuardar = true;
        axios
        .post(this.UrlBase+'/enlace/set_enlace/'+this.reg, this.form)
        .then(r => {
          if (r.data.exito) {
            this.showSuccessMsg({message: r.data.mensaje});
            if (this.reg == '') {
              this.limpiar();
            }

            if (this.form.anulado) {
              this.buscar();
              this.limpiar();
            }

            if (r.data.linea) {
              this.lista.push(r.data.linea);
            }
          } else {
            this.showWarnMsg({message: r.data.mensaje});
          }
          this.btnGuardar = false;
        })
        .catch(e => {
          this.showErrorMsg({message: e});
          this.btnGuardar = false;
        });
      }
    },
    watch: {
      reg (valor) {
        if (valor) {
          this.getMesas();
        }
      }
    }
  }
</script>